// extracted by mini-css-extract-plugin
export var checkboxInputRow = "y_sl";
export var checkboxInputColumn = "y_sm";
export var inputOptionRow = "y_pT";
export var inputOptionColumn = "y_pV";